import {
  ALTERNATIVE_DICE_MARKET_TYPE,
  ALTERNATIVE_DICE_RANGE_LIMIT_OPTIONS,
  ALTERNATIVE_DICE_RANGE_SIDE,
  ALTERNATIVE_DICE_RANGE_TYPE,
} from '../constants';

export const getOdd = (rangeValue, rangeType, rtp) => {
  if (rangeType === ALTERNATIVE_DICE_MARKET_TYPE.In) {
    return (
      (((10000 * rtp) /
        (+rangeValue[ALTERNATIVE_DICE_RANGE_SIDE.To] -
          +rangeValue[ALTERNATIVE_DICE_RANGE_SIDE.From] +
          1)) *
        100) /
      100
    );
  }
  return (
    rtp /
    (1 -
      (+rangeValue[ALTERNATIVE_DICE_RANGE_SIDE.To] -
        +rangeValue[ALTERNATIVE_DICE_RANGE_SIDE.From] +
        1) /
        10000)
  );
};

export const countValidRangeValueByOdd = ({ rangeValue, odd, rangeType, rtp, isMultiple }) => {
  if (rangeType === ALTERNATIVE_DICE_MARKET_TYPE.In) {
    return {
      [ALTERNATIVE_DICE_RANGE_SIDE.To]: Math.ceil(
        (rtp * 10000) / odd + rangeValue[ALTERNATIVE_DICE_RANGE_SIDE.From] - (isMultiple ? 0 : 2)
      ),
      [ALTERNATIVE_DICE_RANGE_SIDE.From]: Math.floor(
        rangeValue[ALTERNATIVE_DICE_RANGE_SIDE.To] + (isMultiple ? 3 : 2) - (10000 * rtp) / odd
      ),
    };
  }
  return {
    [ALTERNATIVE_DICE_RANGE_SIDE.To]: Math.floor(
      rangeValue[ALTERNATIVE_DICE_RANGE_SIDE.From] + 1 + (1 - rtp / odd) * 10000
    ),
    [ALTERNATIVE_DICE_RANGE_SIDE.From]: Math.ceil(
      rangeValue[ALTERNATIVE_DICE_RANGE_SIDE.To] - 1 - (1 - rtp / odd) * 10000
    ),
  };
};

export const differenceBetweenSideByRtp = (rtp, rangeType, odd) => {
  if (rangeType === ALTERNATIVE_DICE_MARKET_TYPE.In) {
    return Math.ceil((rtp * 10000) / odd - 2);
  }
  return Math.floor((1 - rtp / odd) * 10000);
};

export const rangeValuesForView = ({ rangeType, from, to }) => {
  if (rangeType === ALTERNATIVE_DICE_MARKET_TYPE.Out) {
    return `${ALTERNATIVE_DICE_RANGE_LIMIT_OPTIONS.min}-${from},${to}-${ALTERNATIVE_DICE_RANGE_LIMIT_OPTIONS.max}`;
  }
  return `${from}-${to}`;
};

export function detectLegendActivityOfAltDice(rangeValue, legendValue, rangeType) {
  if (rangeType === ALTERNATIVE_DICE_RANGE_TYPE.IN) {
    return rangeValue[0] <= legendValue && rangeValue[1] >= legendValue ? 'active' : '';
  }
  return rangeValue[0] >= legendValue || rangeValue[1] <= legendValue ? 'active' : '';
}
